import React, { useEffect, useContext, useState } from "react";
import PropTypes from "prop-types";
import { useQuery } from "react-apollo";
import Select from "react-select";

import { Field, Label, Help, Generic } from "rbx";
import { Link } from "react-router-dom";

import { ModalContext } from "../ModalProvider";
import { ALL_VEHICLES_QUERY } from "../../graphql/Vehicles/Vehicles.graphql";

const VehicleMultiSelect = ({
  label,
  size,
  name,
  onChange,
  disabled,
  value,
  showHelp,
  orderByNumber,
  required,
  vehicleStatus = false,
  Vehicle,
  isMulti,
  showBlank
}) => {
  const where = vehicleStatus ? { StatusRecIdRef_in: vehicleStatus } : {};
  const [selected, setSelected] = useState([]);
  const [options, setOptions] = useState([]);
  const { data, loading } = useQuery(ALL_VEHICLES_QUERY, {
    variables: {
      where,
      orderBy: orderByNumber ? "VehicleNumber_ASC" : "Description_ASC",
      orderByMulti: orderByNumber ? ["VehicleNumber_ASC"] : ["Description_ASC"]
    }
  });
  const { setModalOpen } = useContext(ModalContext);

  useEffect(() => {
    if (
      isMulti &&
      data &&
      !loading &&
      Array.isArray(data.Vehicles) &&
      data.Vehicles.length > 0 &&
      options.length === 0
    ) {
      const result = data.Vehicles.map(vehicle => ({
        value: vehicle.RecId,
        label: `${vehicle.VehicleNumber} - ${vehicle.Description}`
      }));
      setOptions(
        showBlank ? [{ label: "Blank", value: null }, ...result] : result
      );
    }
    if (Array.isArray(value) && options.length > 0) {
      const newValue = options.filter(opt => value.some(x => opt.value === x));
      setSelected(newValue);
    }
  }, [
    Vehicle,
    data,
    isMulti,
    loading,
    onChange,
    options,
    options.length,
    orderByNumber,
    selected.length,
    showBlank,
    value
  ]);

  const helpText = Vehicle
    ? [Vehicle.VehicleNumber, Vehicle.SerialNumber, Vehicle.Make, Vehicle.Model]
        .filter(x => !!x)
        .join(" - ")
    : " ";

  const handleChange = multiValue => {
    setSelected(multiValue);
    onChange({
      target: {
        name,
        type: "select",
        value: Array.isArray(multiValue) ? multiValue.map(v => v.value) : null
      }
    });
  };

  return (
    <Field>
      <Label size={size}>{label}</Label>
      <Select
        isMulti
        closeMenuOnSelect={false}
        disabled={disabled}
        isLoading={loading}
        name={name}
        options={options}
        required={required}
        styles={{
          menu: provided => ({
            ...provided,
            zIndex: 999
          })
        }}
        value={selected}
        onChange={handleChange}
      />
      {showHelp && value && (
        <Help as={Label} style={{ marginLeft: "2.5rem" }}>
          <Generic
            as={Link}
            tabIndex="-1"
            textColor="link"
            to={`/fleet/vehicles/${value}/profile`}
            onClick={() => setModalOpen(false)}
          >
            {helpText}
          </Generic>
        </Help>
      )}
    </Field>
  );
};

VehicleMultiSelect.propTypes = {
  value: PropTypes.number,
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  showHelp: PropTypes.bool,
  orderByNumber: PropTypes.bool,
  required: PropTypes.bool,
  vehicleStatus: PropTypes.array,
  Vehicle: PropTypes.object,
  isMulti: PropTypes.bool,
  showBlank: PropTypes.bool
};

VehicleMultiSelect.defaultOptions = {
  isLoading: null,
  firstOptionEnabled: false,
  showBlank: false,
  isMulti: false
};

VehicleMultiSelect.displayName = "VehicleMultiSelect";

export default VehicleMultiSelect;
